TermService = ($http, $location, returnUrlAfterTerm) ->
  get: ->
    $http.get('/api/term.json')

  accept: ->
    $http.put('/api/term/accept.json')
    .then (response) ->
      $location.path returnUrlAfterTerm.url

  acceptLocal: (version) ->
    localStorage.setItem "acceptedTermVersion", version
    $location.path('/registration/email')

  isAccepted: ->
    localStorage.getItem "acceptedTermVersion"

  getAcceptedTermVersion: ->
    localStorage.getItem 'acceptedTermVersion'

  clearAcceptLocal: ->
    localStorage.removeItem 'acceptedTermVersion'

TermService.$inject = [
  '$http'
  '$location'
  'returnUrlAfterTerm'
]

module.exports = TermService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/term/term-service.coffee